import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React from 'react';
import useDerivedState from '../../../hooks/useDerivedState.js';
import useId from '../../../hooks/useId.js';

/*eslint-disable */
var closeIcon = (function (_ref) {
  var alt = _ref.alt,
    controlledId = _ref.id;
  var _useDerivedState = useDerivedState(useId('close-id-'), controlledId),
    _useDerivedState2 = _slicedToArray(_useDerivedState, 1),
    id = _useDerivedState2[0];
  return /*#__PURE__*/React.createElement("svg", {
    width: "19px",
    height: "19px",
    focusable: "false",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, alt), /*#__PURE__*/React.createElement("g", {
    id: "".concat(id, "-outer"),
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "".concat(id, "-inner"),
    transform: "translate(-935.000000, -6115.000000)",
    stroke: "#34384B",
    strokeWidth: "3.4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(934.000000, 6114.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "".concat(id, "-path"),
    d: "M10.5,10.4337769 L3,3 L10.5,10.4337769 L3,17.8675537 L10.5,10.4337769 Z M10.5,10.4337769 L18,3 L10.5,10.4337769 L18,17.8675537 L10.5,10.4337769 Z"
  })))));
});

export { closeIcon as default };
